<!-- 余额 -->
<template>
    <div class="wallet">
        <div class="wallet-header">
            <div class="wallet-header-img">
                <div class="title">我的代付余额(元)</div>
                <div class="num">{{ Number(walletBalance).toFixed(2) }}</div>
            </div>

            <van-button v-if="isRecharge" @click="toRecharge" class="wallet-header-button">充值</van-button>

        </div>

        <div class="wallet-container">
            <date-picker :isFixed="false" :date.sync="query.billDate" type="year-month" title="选择年月">
                <template #left>
                    <div class="wallet-container-header flex align-center">
                        <img src="@/assets/images/mine/balance.png" alt="" />
                        <span>账单明细</span>
                    </div>

                    <div class="wallet-site flex align-center">
                        <span class="text-cut wallet-site-name" @click="changeType">{{ typeName }}</span> <van-icon name="arrow-down" />
                    </div>
                </template>
            </date-picker>
            <lazy-load-list :getData="initData" :description="'暂无代付明细'" :query="query">
                <template v-slot="slotData">
                    <div class="bill-list">
                        <div class="bill-list-item flex align-center" v-for="(item, index) in slotData.dataList" :key="index">
                            <div class="bill-list-item-left flex">
                                <img v-if="item.orderType == 2" src="@/assets/images/mine/parking.png" alt="" />
                                <img v-if="item.orderType == 10" src="@/assets/images/mine/market.png" alt="" />
                                <div>
                                    <div class="left-container">
                                        <span v-if="item.orderType == 10">代付充值</span>
                                        <span v-else-if="item.orderType == 2">停车代付</span>
                                    </div>
                                    <div class="left-container" v-if="item.orderType == 2">
                                        代付车牌：{{item.plateNum}}
                                    </div>
                                    <div class="time">{{ item.payTime }}</div>
                                </div>
                            </div>
                            <div class="bill-list-item-right">
                                <div v-if="item.orderType == 10">+{{ Number(item.orderMoney).toFixed(2) }}</div>
                                <div v-else-if="item.orderType != 10">-{{ Number(item.orderMoney).toFixed(2) }}</div>

                            </div>
                        </div>
                    </div>
                </template>
            </lazy-load-list>
        </div>

        <van-action-sheet v-model="showDatePick">
            <div class="content">
                <van-picker title="选择交易类型" show-toolbar value-key="name" :columns="typeList" @confirm="typeOnConfirm" @cancel="typeOnCancel" @change="typeOnChange" />
            </div>
        </van-action-sheet>

    </div>
</template>

<script>
import { listMyPaymentOnBehalfBill, getMerchantMoney, getMerchantChargeConfig } from "@/api/api";
import DatePicker from "@/components/base/datePicker/date-picker.vue";
import LazyLoadList from "@/components/base/lazyLoadList/lazy-load-list.vue";
import { Picker } from "vant";


export default {
    name: "paymentWallet",
    components: {
        DatePicker,
        LazyLoadList,
        "van-picker": Picker,
    },
    data() {
        return {
            walletBalance: "0.00", //用户余额
            query: {
                billDate: "2021-10",
                pageNum: 0,
                pageSize: 10,
                orderType: "",
            },
            typeName: "全部交易类型",

            showDatePick: false,

            typeList: [
                { id: 0, name: "全部交易类型" },
                { id: 2, name: "停车代付" },
                { id: 10, name: "代付充值" },

            ], //

            isRecharge: false, //是否能充值


        };
    },

    computed: {},
    watch: {
        // "query.date": {
        //     handler(newValue, oldValue) {
        //         this.getBillMoney({ date: newValue, type: this.query.type });
        //     },
        //     deep: true,
        //     immediate: false,
        // },
    },
    mounted() {
        this.getWallet()
        getMerchantChargeConfig().then((res) => {
            this.isRecharge = res.data.status == 1 ? true : false;
        });



    },

    methods: {
        //给子组件用
        initData() {
            return listMyPaymentOnBehalfBill(this.query);
        },

        //获取余额余额
        getWallet() {
            getMerchantMoney().then((res) => {
                this.walletBalance = res.data.useMoney;
            });
        },

        //跳转到充值页面
        toRecharge() {
            this.$router.push({
                path: "/mine/paymentRecharge",
            });
        },
        // 选择消费类型
        changeType() {
            this.showDatePick = true;
        },

        typeOnConfirm(value) {
            this.query.orderType = value.id ? value.id : "";
            this.typeName = value.name;
            this.showDatePick = false;
        },
        typeOnCancel() {
            this.showDatePick = false;
        },
        typeOnChange() { },





    },
};
</script>
<style lang="less" scoped>
.wallet {
    .wallet-header {
        width: 750px;

        min-height: 240px;
        background-color: #fff;
        padding-top: 16px;
        padding-bottom: 20px;

        text-align: center;
        .wallet-header-img {
            width: 720px;
            height: 240px;
            background: url("~@/assets/images/mine/title.png") no-repeat;
            background-size: 100% 100%;
            margin: 0 auto;
            padding-top: 50px;
            .title {
                color: #fff;
                font-size: 30px;
            }
            .num {
                color: #fff;
                margin-top: 30px;
                font-size: 50px;
            }
        }

        .date-container {
            width: 690px;
            height: 100px;

            margin: 0 auto;
            padding: 12px 0;
            color: #ffa840;
            border-radius: 20px;
            background-color: #fff3e5;
            .top {
                font-size: 30px;
                font-weight: bold;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    width: 30px;
                    height: 30px;
                    margin-left: 10px;
                }
            }
            .bottom {
                font-size: 28px;
            }
        }
        .wallet-header-button {
            // margin: 32px auto 0 auto;
            height: 70px;
            width: 690px;
            background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
            color: #fff;
            border-radius: 10px;
        }
    }

    .wallet-container {
        border-top: 1px solid #dbdada33;
        .wallet-container-header {
            margin-left: 30px;
            color: #666666;
            img {
                width: 32px;
                height: 32px;
                margin-right: 15px;
            }
        }
        .wallet-site {
            margin-right: 10px;
            font-size: 24px;
            color: #666666;
            .wallet-site-name {
                width: 137px;
                text-align: center;
            }
        }

        .wallet-container-middle {
            height: 60px;
            line-height: 60px;
            padding-left: 36px;
            color: #a3a3a3;
        }
    }
}

.bill-list {
    margin-top: 20px;
    .bill-list-item {
        min-height: 128px;
        padding: 20px;
        border-bottom: 1px solid #dbdada33;
        justify-content: space-between;
        background-color: #fff;
        img {
            height: 70px;
            width: 70px;
            margin-right: 25px;
        }

        .bill-list-item-left {
            .left-container {
                font-size: 30px;
                margin-bottom: 10px;
            }
            .time {
                font-size: 25px;

                color: #999;
            }
        }
        .bill-list-item-right {
            font-size: 40px;
            // border: 1px red solid;
        }
    }
}
.toll-rule-wrap {
    border-radius: 20px;
    background-color: #fff;
    padding-bottom: 30px;

    .toll-rule-wrap-header {
        padding: 32px;
        font-size: 34px;
        border-bottom: 1px solid #d5d5d5;
        color: #212121;

        img {
            width: 40px;
            height: 40px;
        }
    }

    .toll-rule-item {
        padding: 0 30px;
        margin: 30px 0;

        .toll-rule-item-title {
            font-size: 30px;
            color: #212121;
        }

        .toll-rule-item-content {
            font-size: 30px;
            color: #333333;
            margin-top: 10px;
        }
    }
}
</style>
